import { Button, cardClass } from '@ledgerloom/ui';
import { useEffect, useState } from 'react';
import type { Me } from '../api';
import { Mfa } from './Admin';

// Where two-factor sign-in is required, an owner or admin turns it on before
// anything else (after a temporary password), then signs in again with a code:
// only a session signed in with one counts. Pattern: authentication/two-factor.
export function MfaSetup({ me, onSignOut }: { me: Me; onSignOut: () => void }) {
  const [enabled, setEnabled] = useState(me.mfa_enabled);
  useEffect(() => { document.title = 'Turn on two-factor sign-in · Mazu'; }, []);
  return (
    <main className="login" id="main">
      <div className="stack login-col">
        <div className="row"><img src="/icon.svg" alt="" width={32} height={32} /><h1>Turn on two-factor sign-in</h1></div>
        {enabled ? (
          <div className={`${cardClass} card-pad stack`} role="status">
            <p style={{ margin: 0 }}>Two-factor sign-in is on. Sign in again with a code from your authenticator app to continue.</p>
            <Button type="submit" style={{ alignSelf: 'flex-start' }} onClick={onSignOut}>Sign in again</Button>
          </div>
        ) : <>
          <p className="muted" style={{ margin: 0 }}>{me.tenant_name} asks owners and admins for a code from an authenticator app at every sign-in. Set it up to go on.</p>
          <Mfa enabled={false} onEnabled={() => setEnabled(true)} />
          <Button type="button" variant="ghost" size="sm" style={{ alignSelf: 'flex-start', paddingLeft: 0 }} onClick={onSignOut}>Sign out</Button>
        </>}
      </div>
    </main>
  );
}
